import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../config";
import { ScheduledInvoiceItem } from "./useCreateInvoiceSchedule";


type CreateScheduleInput = {
    order: number;
    scheduled_date: string;
    status: "scheduled";
};

type BulkCreateSchedulesInput = {
    schedules: Array<CreateScheduleInput>;
    items: Array<ScheduledInvoiceItem>;
};

export const useBulkCreateSchedules = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (input: BulkCreateSchedulesInput) => bulkCreateSchedules(input),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ["scheduled-invoices"] });
        },
    });
};

const bulkCreateSchedules = async (input: BulkCreateSchedulesInput) => {
    const response = await api({
        method: "POST",
        url: "/items/scheduled_invoices",
        data: input.schedules,
    });

    const createdSchedules = response.data.data;

    if (input.items && input.items.length > 0) {
        try {
            const allItemsToCreate = createdSchedules.map((schedule: any, index: number) => {
                const item = input.items[index];
                return {
                    scheduled_invoice: schedule.id,
                    service: typeof item.service === "object" ? item.service.id : item.service,
                    quantity: item.quantity,
                    price: item.price,
                };
            });

            await api({
                method: "POST",
                url: "/items/scheduled_invoices_items",
                data: allItemsToCreate,
            });
        } catch (error) {
            const scheduleIds = createdSchedules.map((s: any) => s.id);
            await api({
                method: "DELETE",
                url: "/items/scheduled_invoices",
                data: scheduleIds,
            });
            throw error;
        }
    }

    return createdSchedules;
};
